import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterStatusChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityStatusTransition,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface MatterStatusChangedEventProps {
  event: DiscriminatedMatterStatusChangedEvent;
}

export const MatterStatusChangedEvent: React.FC<
  MatterStatusChangedEventProps
> = ({ event }) => {
  const { matter, old_status, new_status } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-purple-100">
          <ArrowPathIcon className="h-4 w-4 text-purple-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="flex items-center gap-3">
        {matter?.name && <ActivityTitle>{matter.name}</ActivityTitle>}
        {old_status && new_status && (
          <ActivityStatusTransition
            from={formatStatus(old_status)}
            to={formatStatus(new_status)}
          />
        )}
      </div>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Matter Status Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
